import script from "./FvContent.vue?vue&type=script&setup=true&lang=js"
export * from "./FvContent.vue?vue&type=script&setup=true&lang=js"

import "./FvContent.vue?vue&type=style&index=0&id=bf05776c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf05776c"]])

export default __exports__